export const formatEnumFromDB = (enumName: string | undefined): string => {
  if (enumName) {
    return enumName.split('_').join(' ')
  }

  return ''
}
